module.exports = __webpack_public_path__ + "img/dartLogoS.5cc6f78.png";